module.exports = __webpack_public_path__ + "img/95.8fb8d186.jpg";